/** @jsxImportSource @emotion/react */
import { useTheme, loaderImage } from '../..';

export const Loader = () => {
  const { spacing } = useTheme();
  return (
    <div
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        img: {
          height: spacing.l,
        },
      }}
    >
      <img src={loaderImage} />
    </div>
  );
};
